var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("h6", [_vm._v("Station " + _vm._s(_vm.name))]),
      _vm._v(" "),
      _c(
        "v-form",
        { attrs: { box: "" } },
        [
          _c("v-text-field", {
            attrs: { label: "Site ID", disabled: "", box: "" },
            model: {
              value: _vm.station.siteid,
              callback: function ($$v) {
                _vm.$set(_vm.station, "siteid", $$v)
              },
              expression: "station.siteid",
            },
          }),
          _vm._v(" "),
          _c("v-text-field", {
            attrs: { label: "Site Description", "multi-line": "", box: "" },
            model: {
              value: _vm.station.shortsitedescription,
              callback: function ($$v) {
                _vm.$set(_vm.station, "shortsitedescription", $$v)
              },
              expression: "station.shortsitedescription",
            },
          }),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { staticClass: "ma-2", attrs: { xs6: "" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "Latitude", box: "" },
                    model: {
                      value: _vm.station.latitude,
                      callback: function ($$v) {
                        _vm.$set(_vm.station, "latitude", $$v)
                      },
                      expression: "station.latitude",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "ma-2", attrs: { xs6: "" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "Longitude", box: "" },
                    model: {
                      value: _vm.station.longitude,
                      callback: function ($$v) {
                        _vm.$set(_vm.station, "longitude", $$v)
                      },
                      expression: "station.longitude",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-select", { attrs: { label: "Type", items: _vm.types } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }